var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.114,
    height: 244.285,
    viewBox: "0 0 324.114 244.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.3;}.b,.c,.g{fill:none;}.b,.c{stroke:#fff;stroke-width:2px;}.c{stroke-linecap:round;}.d{fill:#fff;font-size:32px;font-family:RobotoMono-Bold, Roboto Mono;font-weight:700;letter-spacing:0.15em;}.e{fill:rgba(255,255,255,0.3);}.f{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-985 -1111)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 -141.465)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(968.875 1272.784)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.125 -20.319)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 324.114,
    height: 201.477,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 1,
    y: 1,
    width: 322.114,
    height: 199.477,
    rx: 15
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 42,
    transform: "translate(162.625 181.157)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 187,
    transform: "translate(68.625 222.966)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(68.625 42.919)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "{"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 50
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 100
  }, "}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.262 1380.354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.262 -41.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 42,
    height: 2,
    rx: 1,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 42,
    height: 2,
    rx: 1,
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 42,
    height: 2,
    rx: 1,
    transform: "translate(18 17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 42,
    height: 2,
    rx: 1,
    transform: "translate(9 26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 60,
    height: 2,
    rx: 1,
    transform: "translate(0 34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(45 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 14,
    height: 2,
    rx: 1,
    transform: "translate(55 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(73 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(64 17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 62,
    height: 2,
    rx: 1,
    transform: "translate(60 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 44,
    height: 2,
    rx: 1,
    transform: "translate(55 26)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.11751d46f90177e85b087950bf97f53d.svg";
export { ForwardRef as ReactComponent };